export type PanelVariant = "primary" | "standard" | "muted";

// 디자인 원칙: border 제거 (페이지 bg-gray-50 vs panel bg-white 색 대비 + 그림자로 elevation 표현).
// 보더 line이 만들던 "빈 frame" 효과 제거 → 패널 내부 빈 여백이 자연스러운 흰 영역으로 인식.
// padding 축소 (p-5→p-4, p-4→p-3) — 모던 dashboard 표준 (Linear/Vercel) 정렬, 컨텐츠 영역 확장.
const VARIANTS: Record<PanelVariant, string> = {
  // L3 — 결론·핵심 강조 (강한 elevation: ring + shadow)
  primary:
    "bg-white rounded-xl ring-1 ring-slate-900/5 " +
    "shadow-[0_4px_12px_-2px_rgba(15,23,42,0.08)] p-4",
  // L2 — 표준 (subtle shadow only)
  standard:
    "bg-white rounded-xl " +
    "shadow-[0_1px_3px_0_rgba(0,0,0,0.05),0_1px_2px_-1px_rgba(0,0,0,0.04)] p-3",
  // L1 — 보조 (slate bg 색 대비만, no shadow)
  muted: "bg-slate-50 rounded-xl p-3",
};

export function panelCls(
  variant: PanelVariant = "standard",
  extra = "",
): string {
  return `${VARIANTS[variant]} ${extra}`.trim();
}
